
import { defineComponent } from 'vue'
import { LocalizationPath } from '@tokyojob/core'
import { getLocalization } from '@tokyojob/frontend-components'
import { LocalizationService } from '@tokyojob/frontend-core'
import { getProvidedApp } from '~/base/utils/provided-getter'

interface ISetup {
  pleaseContact: string
  pleaseContactLink: string
}

export default defineComponent({
  props: {
    alertBodyText: {
      type: String,
      required: false
    }
  },
  setup(): ISetup {
    const localization = getLocalization(getProvidedApp())
    const pleaseContact = LocalizationService.t<string>(localization, LocalizationPath.ModalPleaseContact)
    const pleaseContactLink = LocalizationService.t<string>(localization, LocalizationPath.ModalPleaseContactLink)
    return {
      pleaseContact,
      pleaseContactLink
    }
  }
})
